import { useLocation } from 'react-router-dom'
import { buildContactUrl, getContactBranchFromPathname } from '../constants/contact'

export function useContactHref(options = {}) {
  const { pathname } = useLocation()
  const branchFromPage = getContactBranchFromPathname(pathname)

  return buildContactUrl({
    branch: options.branch ?? branchFromPage,
    subject: options.subject,
    event: options.event,
  })
}
